import React, {Component} from 'react';
import {
    BUDGET_INDICATORS,
    CONVERSIONS_INDICATORS,
    TODAY_INDICATOR_NAMES,
    FUNDS_INDICATORS,
    GOALS_INDICATORS,
    getIndicatorData
} from "../../indicators";
import {TwoLevelIndicatorSensitivity} from "../agency/settings/TwoLevelIndicatorSensitivity";
import {SingleLevelIndicatorSensitivity} from "../agency/settings/SingleLevelIndicatorSensitivity";
import {Spinner} from "../Spinner";
import {AlertsConfigurationSection} from "./AlertsConfigurationSection";
import { withTranslation } from 'react-i18next';

class AlertsConfigurationClass extends Component {
    constructor(props) {
        super(props);

        this.handleStatusChange = this.handleStatusChange.bind(this);
        this.handleSensitivityChange = this.handleSensitivityChange.bind(this);
    }

    // handlers

    handleSensitivityChange(indicatorName, levelName, value) {
        let indicators = this.props.indicators;

        indicators[indicatorName].sensitivity_values = indicators[indicatorName].sensitivity_values.map(sensitivityValue => {
            if (sensitivityValue.level === levelName) {
                return {
                    level: levelName,
                    value: value
                }
            } else {
                return sensitivityValue
            }
        });

        this.props.onIndicatorsChange(indicators);
    }

    handleStatusChange(indicatorName, shouldActivate) {
        let indicators = this.props.indicators;

        indicators[indicatorName].is_active = shouldActivate;

        this.props.onIndicatorsChange(indicators);
    }

    // rendering

    renderSingleLevelSensitivities(indicators) {
        const { t } = this.props;
        return indicators.map(indicatorName => {
            const indicatorData = getIndicatorData(indicatorName, t);
            return <SingleLevelIndicatorSensitivity indicatorName={indicatorName}
                                                    key={indicatorName}
                                                    indicatorTitle={indicatorData['title']}
                                                    indicatorSubtitle={indicatorData['subtitle']}
                                                    isActive={this.props.indicators[indicatorName].is_active}
                                                    sensitivityValues={this.props.indicators[indicatorName].sensitivity_values}
                                                    sensitivityUnit={indicatorData['sensitivity_unit']}
                                                    handleStatusChange={this.handleStatusChange}
                                                    handleSensitivityChange={this.handleSensitivityChange}
            />
        })
    }

    renderTwoLevelSensitivities(indicators) {
        const { t } = this.props;
        return indicators.map(indicatorName => {
            const indicatorData = getIndicatorData(indicatorName, t);
            return <TwoLevelIndicatorSensitivity indicatorName={indicatorName}
                                                 key={indicatorName}
                                                 indicatorTitle={indicatorData['title']}
                                                 indicatorSubtitle={indicatorData['subtitle']}
                                                 badLabel={indicatorData['badLabel']}
                                                 criticalLabel={indicatorData['criticalLabel']}
                                                 sensitivityUnit={indicatorData['sensitivity_unit']}
                                                 isActive={this.props.indicators[indicatorName].is_active}
                                                 sensitivityValues={this.props.indicators[indicatorName].sensitivity_values}
                                                 handleStatusChange={this.handleStatusChange}
                                                 handleSensitivityChange={this.handleSensitivityChange}
            />
        });
    }

    render() {
        const { t } = this.props;
        if (this.props.indicators !== null) {

            const todayAlertsExplanationText = <span style={{marginBottom:"1em"}}><p>{t('alerts_configuration.today_alerts_explanation_1')}</p>
                        <p>{t('alerts_configuration.today_alerts_explanation_2')}</p></span>

            const conversionAlertsExplanationText = <span style={{marginBottom:"1em"}}><p>{t('alerts_configuration.conversion_alerts_explanation_1')}</p>
                        <p>{t('alerts_configuration.conversion_alerts_explanation_2')}</p></span>

            const budgetAlertsExplanationText = <span style={{marginBottom:"1em"}}><p>{t('alerts_configuration.budget_alerts_explanation_1')}</p>
                        <p>{t('alerts_configuration.budget_alerts_explanation_2')}</p></span>

            const fundsAlertsExplanationText = <span style={{marginBottom:"1em"}}><p>{t('alerts_configuration.funds_alerts_explanation')}</p></span>

            const goalsAlertsExplanationText =  <span style={{marginBottom:"1em"}}><p>{t('alerts_configuration.goals_alerts_explanation')}</p></span>

            const flexIndicatorsAlertsExplanationText =  <span style={{marginBottom:"1em"}}><p>{t('alerts_configuration.flex_indicators_alerts_explanation')}</p></span>

            const ecommerceAlertsExplanationText =  <span style={{marginBottom:"1em"}}><p>{t('alerts_configuration.ecommerce_alerts_explanation')}</p></span>

            return (
                <form>

                    <AlertsConfigurationSection sectionName={t('alerts_configuration.budget_alerts')}>
                        {budgetAlertsExplanationText}
                        {this.renderTwoLevelSensitivities(BUDGET_INDICATORS)}
                    </AlertsConfigurationSection>

                    <AlertsConfigurationSection sectionName={t('alerts_configuration.conversion_alerts')}>
                        {conversionAlertsExplanationText}
                        {this.renderTwoLevelSensitivities(CONVERSIONS_INDICATORS)}
                    </AlertsConfigurationSection>

                    <AlertsConfigurationSection sectionName={t('alerts_configuration.today_alerts')}>
                        {todayAlertsExplanationText}
                        {this.renderSingleLevelSensitivities(TODAY_INDICATOR_NAMES)}
                    </AlertsConfigurationSection>

                    <AlertsConfigurationSection sectionName={t('alerts_configuration.balance_control')}>
                        {fundsAlertsExplanationText}
                        {this.renderTwoLevelSensitivities(FUNDS_INDICATORS)}
                    </AlertsConfigurationSection>

                    <AlertsConfigurationSection sectionName={t('alerts_configuration.period_goals')}>
                        {goalsAlertsExplanationText}
                        {this.renderTwoLevelSensitivities(GOALS_INDICATORS)}
                    </AlertsConfigurationSection>

                    {this.renderFlexIndicators(flexIndicatorsAlertsExplanationText)}
                    {this.renderEcommerceIndicators(ecommerceAlertsExplanationText)}
                </form>
            );
        } else {
            return (
                <div className="box-loader">
                    <Spinner color="positive"/>
                </div>
            )
        }
    }

    renderNotFlexIndicatorsCreatedText() {
        const { t } = this.props;
        if (!this.props.agencyFlexIndicators || this.props.agencyFlexIndicators.length === 0) {
            return <div className="form-row">
                <div className="alert alert-info">
                    {t('alerts_configuration.create_custom_columns_message')}
                </div>
            </div>
        }
        return null;
    }

    renderFlexIndicators(flexIndicatorsAlertsExplanationText) {
        const { t } = this.props;
        const agencyFlexIndicators = this.props.agencyFlexIndicators || [];
        return <AlertsConfigurationSection sectionName={t('alerts_configuration.custom_columns')}>
            {flexIndicatorsAlertsExplanationText}
            {this.renderNotFlexIndicatorsCreatedText()}
            {this.renderTwoLevelSensitivities(agencyFlexIndicators)}
        </AlertsConfigurationSection>;
    }

    renderEcommerceTwoLevelSensitivities(indicators) {
        const { t } = this.props;
        return indicators.map(indicatorName => {
            const indicatorData = getIndicatorData(indicatorName, t);
            const title = indicatorData['title'] ? indicatorData['title'].replace(' (Ecommerce)', '') : '';
            return <TwoLevelIndicatorSensitivity indicatorName={indicatorName}
                                                 key={indicatorName}
                                                 indicatorTitle={title}
                                                 indicatorSubtitle={indicatorData['subtitle']}
                                                 badLabel={indicatorData['badLabel']}
                                                 criticalLabel={indicatorData['criticalLabel']}
                                                 sensitivityUnit={indicatorData['sensitivity_unit']}
                                                 isActive={this.props.indicators[indicatorName].is_active}
                                                 sensitivityValues={this.props.indicators[indicatorName].sensitivity_values}
                                                 handleStatusChange={this.handleStatusChange}
                                                 handleSensitivityChange={this.handleSensitivityChange}
            />
        });
    }

    renderEcommerceIndicators(ecommerceAlertsExplanationText) {
        const { t } = this.props;
        const agencyEcommerceFixedFlexIndicators = this.props.agencyEcommerceFixedFlexIndicators || [];
        
        if (agencyEcommerceFixedFlexIndicators.length === 0) {
            return null;
        }

        return <AlertsConfigurationSection sectionName={t('alerts_configuration.ecommerce_alerts')}>
            {ecommerceAlertsExplanationText}
            {this.renderEcommerceTwoLevelSensitivities(agencyEcommerceFixedFlexIndicators)}
        </AlertsConfigurationSection>;
    }
}

export const AlertsConfiguration = withTranslation()(AlertsConfigurationClass);
export default AlertsConfiguration;
